import { Injectable, OnDestroy } from '@angular/core';
import { BaseService } from '../base.service';
import { BehaviorSubject, Subject, takeWhile } from 'rxjs';
import { MetaDataModel } from './models/sharedModel';
import { PartnerDataModel } from '../account/models/accountModel';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AlertBtnText, AlertTypes, AppStatesTexts, UserRoles } from '../constants';
const STORE_USER_KEY = 'store-user-details-auth';
const STORE_BRAND_KEY = 'store-user-branding-details';
const MANAGE_METADATA_KEY = 'mng-user-metadata-details';
const STORE_METADATA_KEY = 'store-user-metadata-details';

@Injectable({
  providedIn: 'root'
})
export class SharedService implements OnDestroy {

  destroySubscription = false;

  owlCarouselCustomOptions = {
    startPosition: 0,
    margin: 20,
    autoWidth: true,
    autoplay: true,
    rewind: true,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    responsive: {
      0: {
        items: 3
      },
      537: { // as owl carouser consider window width over viewport width for responsive width applied here is 576 + 38 = 538 - 1 which is (575 and above)
        items: 5
      },
      730: { // as owl carouser consider window width over viewport width for responsive width applied here is 768 - 38 = 730 - 1 which is (767 and above)
        items: 8
      }
    },
    nav: false
  }

  metadataInit: MetaDataModel = {
    app_statuses: [],
    app_types: [],
    customer_app_enable_states: [],
    partner_app_access_levels: [],
    partner_app_enable_states: [],
    partner_registration_statuses: [],
    vendor_statuses: [],
    auth_types: [],
    geospec: [],
    workflow_tasks: [],
    workflow_type: []
  }

  // metadatasub = new BehaviorSubject<any>(this.metadataInit);
  // metadata = this.metadatasub.asObservable();

  brandingDataSub = new Subject();
  brandingData = [];
  brandColorSub = new BehaviorSubject<any>('');
  brandColorSrc = this.brandColorSub.asObservable();

  appMetaDataSub = new Subject();
  appMetaData: MetaDataModel;
  metaDataSub = new BehaviorSubject<any>('');
  metaDataSrc = this.metaDataSub.asObservable();

  constructor(private baseService: BaseService) {
    this.getBrandColor();
    this.getMetadataValues();
    this.subscriptions();
  }

  subscriptions() {
    this.brandingDataSub.pipe(takeWhile(() => !this.destroySubscription))
      .subscribe((response: any) => {
        if (response) {
          this.brandingData = response;
          if (this.brandingData) {
            this.applyBranding(this.brandingData);
          }
        }
      });

    this.appMetaDataSub.pipe(takeWhile(() => !this.destroySubscription))
      .subscribe((response: any) => {
        if (response) {
          this.appMetaData = response;
          if (this.appMetaData) {
            this.metaDataSub.next(this.appMetaData);
          }
        }
      });
  }

  getBrandColor() {
    const brandingData = this.getBranding();
    if (brandingData) {
      this.applyBranding(brandingData);
    }
  }

  applyBranding(brandingData: any) {
    const promise = new Promise<any>((resolve, reject) => {
      let matchedCss = {
        brandColor1: '',
        brandColor2: ''
      }
      const user = this.getStoreUser();
      if (brandingData && brandingData.length) {
        matchedCss = this.operateCss1(user, brandingData);
        resolve(matchedCss);
      }

    });

    promise.then((matchedCss) => {
      this.brandColorSub.next(matchedCss);
    });
  }

  operateCss1(user: PartnerDataModel, brandingData: any) {
    let matchedCss = {
      brandColor1: '',
      brandColor2: ''
    }

    let brandColor1 = '';

    for (let i = 0; i < brandingData.length; i++) {
      const css = brandingData[i];

      // if (css.config_name === 'PORTAL_CSS_PRIMARY_1' && !css.is_default) {
      //   brandColor1 = css.config_value;
      //   break;
      // } else if (css.config_name === 'PORTAL_CSS_PRIMARY_1' && css.is_default) {
      //   brandColor1 = css.config_value;
      //   break;
      // }
      if (user.user_role === UserRoles.officemanager) {
        if (css.config_name === 'PORTAL_CSS_PRIMARY_1' && !css.is_default
          && css.config_value && css.config_value !== 'null' && css.domain !== '*') {
          brandColor1 = css.config_value;
          break;
        } else if (css.config_name === 'PORTAL_CSS_PRIMARY_1' && !css.is_default
          && css.config_value && css.config_value !== 'null' && css.domain === '*') {
          brandColor1 = css.config_value;
          break;
        } else if (css.config_name === 'PORTAL_CSS_PRIMARY_1' && css.is_default
          && css.config_value && css.config_value !== 'null') {
          brandColor1 = css.config_value;
          break;
        }
      } if (user.user_role === UserRoles.reseller) {
        if (css.config_name === 'PORTAL_CSS_PRIMARY_1' && !css.is_default
          && css.config_value && css.config_value !== 'null' && css.domain !== '*') {
          brandColor1 = css.config_value;
          break;
        } else if (css.config_name === 'PORTAL_CSS_PRIMARY_1' && !css.is_default
          && css.config_value && css.config_value !== 'null' && css.domain === '*') {
          brandColor1 = css.config_value;
          break;
        } else if (css.config_name === 'PORTAL_CSS_PRIMARY_1' && css.is_default
          && css.config_value && css.config_value !== 'null') {
          brandColor1 = css.config_value;
          break;
        }
      } else {
        if (css.config_name === 'PORTAL_CSS_PRIMARY_1' && !css.is_default
          && css.config_value && css.config_value !== 'null') {
          brandColor1 = css.config_value;
          break;
        } else if (css.config_name === 'PORTAL_CSS_PRIMARY_1' && css.is_default
          && css.config_value && css.config_value !== 'null') {
          brandColor1 = css.config_value;
          break;
        }
      }
    }

    const brandColor2 = this.operateCss2(user, brandingData);

    if (brandColor1 || brandColor2) {
      matchedCss = {
        brandColor1: brandColor1 ? brandColor1 : '',
        brandColor2: brandColor2 ? brandColor2 : '',
      }
    }
    return matchedCss;
  }

  operateCss2(user: PartnerDataModel, brandingData: any) {
    let brandColor2 = '';
    for (let i = 0; i < brandingData.length; i++) {
      const css = brandingData[i];

      // if (css.config_name === 'PORTAL_CSS_PRIMARY_2' && !css.is_default) {
      //   brandColor2 = css.config_value;
      //   break;
      // } else if (css.config_name === 'PORTAL_CSS_PRIMARY_2' && css.is_default) {
      //   brandColor2 = css.config_value;
      //   break;
      // }
      if (user.user_role === UserRoles.officemanager) {
        if (css.config_name === 'PORTAL_CSS_PRIMARY_2' && !css.is_default
          && css.config_value && css.config_value !== 'null' && css.domain !== '*') {
          brandColor2 = css.config_value;
          break;
        } else if (css.config_name === 'PORTAL_CSS_PRIMARY_2' && !css.is_default
          && css.config_value && css.config_value !== 'null' && css.domain === '*') {
          brandColor2 = css.config_value;
          break;
        } else if (css.config_name === 'PORTAL_CSS_PRIMARY_2' && css.is_default
          && css.config_value && css.config_value !== 'null') {
          brandColor2 = css.config_value;
          break;
        }
      } if (user.user_role === UserRoles.reseller) {
        if (css.config_name === 'PORTAL_CSS_PRIMARY_2' && !css.is_default
          && css.config_value && css.config_value !== 'null' && css.domain !== '*') {
          brandColor2 = css.config_value;
          break;
        } else if (css.config_name === 'PORTAL_CSS_PRIMARY_2' && !css.is_default
          && css.config_value && css.config_value !== 'null' && css.domain === '*') {
          brandColor2 = css.config_value;
          break;
        } else if (css.config_name === 'PORTAL_CSS_PRIMARY_2' && css.is_default
          && css.config_value && css.config_value !== 'null') {
          brandColor2 = css.config_value;
          break;
        }
      } else {
        if (css.config_name === 'PORTAL_CSS_PRIMARY_2' && !css.is_default
          && css.config_value && css.config_value !== 'null') {
          brandColor2 = css.config_value;
          break;
        } else if (css.config_name === 'PORTAL_CSS_PRIMARY_2' && css.is_default
          && css.config_value && css.config_value !== 'null') {
          brandColor2 = css.config_value;
          break;
        }
      }
    }

    return brandColor2;
  }

  getMetadataValues() {
    const metadata = this.getMetadata();
    this.metaDataSub.next(metadata);
  }

  public saveStoreUser(user: any): void {
    this.removeStoreUser()
    window.localStorage.setItem(STORE_USER_KEY, JSON.stringify(user));

  }

  public getStoreUser(): any {
    const user = window.localStorage.getItem(STORE_USER_KEY);
    if (user && user !== 'undefined') {
      return JSON.parse(user);
    }
    return null;
  }

  public removeStoreUser() {
    window.localStorage.removeItem(STORE_USER_KEY);
  }

  public saveBranding(brandData: any): void {
    this.removeBranding();
    window.localStorage.setItem(STORE_BRAND_KEY, JSON.stringify(brandData));

  }

  public getBranding(): any {
    const branding = window.localStorage.getItem(STORE_BRAND_KEY);
    if (branding && branding !== 'undefined') {
      return JSON.parse(branding);
    }
    return null;
  }

  public removeBranding() {
    window.localStorage.removeItem(STORE_BRAND_KEY);
  }

  public saveMetadata(metata: any): void {
    this.removeMetadata();
    window.localStorage.setItem(MANAGE_METADATA_KEY, JSON.stringify(metata));

  }

  public getMetadata(): any {
    const metata = window.localStorage.getItem(MANAGE_METADATA_KEY);
    if (metata && metata !== 'undefined') {
      return JSON.parse(metata);
    }
    return null;
  }

  public removeMetadata() {
    window.localStorage.removeItem(MANAGE_METADATA_KEY);
  }

  public saveStoreMetadata(metata: any): void {
    this.removeStoreMetadata();
    window.localStorage.setItem(STORE_METADATA_KEY, JSON.stringify(metata));

  }

  public getStoreMetadata(): any {
    const metata = window.localStorage.getItem(STORE_METADATA_KEY);
    if (metata && metata !== 'undefined') {
      return JSON.parse(metata);
    }
    return null;
  }

  public removeStoreMetadata() {
    window.localStorage.removeItem(STORE_METADATA_KEY);
  }


  numberFormatter = (value: string, code: any) => {
    let number = value.toString();
    if (!number) {
      return '';
    }
    const countryCode = code;
    if (!countryCode || countryCode === '1') {
      return this.formatNumber(number, false);
    } else if (countryCode === '916') {
      // number = number.substring(countryCode.length);
      return '+' + countryCode + ' ' + this.formatNumberA(number, true)
    } else {
      if (number.startsWith(countryCode)) {
        number = number.substring(countryCode.length);

        return (!countryCode.startsWith('+') ? '+' : '') + countryCode + ' ' + this.formatNumberA(number, false);
      } else {
        return (!countryCode.startsWith('+') ? '+' : '') + countryCode + ' ' + this.formatNumberA(number, false);
      }
    }
  }

  /**
  * Format number with defined pattern
  * @param number - Number
  * @param isStartWithNine - True if countryCode starts with 916
  */
  formatNumber(number: any, isStartWithNine: any) {
    if (isStartWithNine) {
      return number.replace(/^(\d{2})(\d{3})(\d{4})$/g, '($1) $2-$3')
    } else {
      // return number.replace(/^(\d{3})(\d{3})(\d{4})$/g, '($1) $2-$3')
      if (number.length > 10) {
        return number.replace(/^(\d+)?(\d{3})(\d{3})(\d{4})$/g, '+$1 ($2) $3-$4')
      } else {
        return number.replace(/^(\d{3})(\d{3})(\d{4})$/g, '($1) $2-$3')
      }
    }
  }

  formatNumberA(number: any, isStartWithNine: any) {
    if (isStartWithNine) {
      return number.replace(/^(\d{2})(\d{3})(\d{4})$/g, '($1) $2-$3')
    } else {
      return number.replace(/^(\d{3})(\d{3})(\d{4})$/g, '($1) $2-$3')
    }
  }



  textComparator = (valueA: any, valueB: any, nodeA: any, nodeB: any) => {
    const valA = valueA ? valueA.toLowerCase() : '';
    const valB = valueB ? valueB.toLowerCase() : '';
    // if (valA === valB) {
    //   return 0;
    // }
    if (!valA) {
      return 1;
    }
    if (!valB) {
      return -1;
    }
    return valA.toLowerCase().localeCompare(valB.toLowerCase());
  }

  numberComparator = (valueA: any, valueB: any, nodeA: any, nodeB: any) => {
    return Number(valueA) - Number(valueB) // valA.toLowerCase().localeCompare(valB.toLowerCase());
  }

  dateComparator = (date1: any, date2: any, nodeA: any, nodeB: any) => {
    const dateA = nodeA.data.updated_datetime_utc;
    const dateB = nodeB.data.updated_datetime_utc;

    var date1Number = dateA && new Date(dateA).getTime();
    var date2Number = dateB && new Date(dateB).getTime();

    if (date1Number == null && date2Number == null) {
      return 0;
    }

    if (date1Number == null) {
      return -1;
    } else if (date2Number == null) {
      return 1;
    }

    return date1Number - date2Number;
  }

  getFullNameForUsers(params: any) {
    const first_name = params.data.first_name;
    const last_name = params.data.last_name;
    let final_name = '';
    if (first_name) {
      final_name = first_name + ' ';
    }
    if (last_name) {
      final_name = final_name + last_name;
    }
    return final_name;
  }

  convertBytes = (bytes: number, isOnlyMB: boolean, isSuffix: boolean, decimals = 2) => {
    // let abcd = (bytes / (1024 * 1024)).toFixed(2);
    if (bytes === 0) {
      return '0 Bytes';
    }

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    let i = Math.floor(Math.log(bytes) / Math.log(k));
    // ignoring KB. Convert KB valu to MB
    if (isOnlyMB) {
      i = 2
    }
    let val;
    if (isSuffix) {
      val = parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    } else {
      val = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    }
    return val;
  }

  getFileNameWithType(fullName: string) {
    const lastDot = fullName.lastIndexOf('.');

    const fileName = fullName.substring(0, lastDot);
    const fileExt = fullName.substring(lastDot + 1);

    return {
      fileName: fileName,
      fileExt: fileExt
    }
  }

  isPdfTypeAllowed(file_type: string) {
    return file_type === 'pdf' || file_type === 'PDF';
  }

  isDocxTypeAllowed(file_type: string) {
    return file_type === 'docx' || file_type === 'DOCX';
  }

  isPptxTypeAllowed(file_type: string) {
    return file_type === 'pptx' || file_type === 'PPTX';
  }

  isXlsxTypeAllowed(file_type: string) {
    return file_type === 'xlsx' || file_type === 'XLSX';
  }

  isUrlTypeAllowed(file_type: string) {
    return file_type === 'url' || file_type === 'URL';
  }

  getRequest(reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.getData(reqUrl + (urlData ? urlData : ''));
  }

  getRequestA(reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.getDataA(reqUrl + (urlData ? urlData : ''));
  }

  postRequest(reqObj: any, reqUrl: string, urlParams?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.postData(reqObj, reqUrl + (urlData ? urlData : ''));
  }

  deleteRequest(deleteUrl: string, urlParams?: any, empId?: any) {
    let urlData = '';
    if (urlParams && urlParams.length) {
      urlParams.forEach((val: any) => {
        urlData += '&' + val.paramLabel + '=' + val.paramValue
      });
    }
    return this.baseService.deleteRequest(deleteUrl + (urlData ? urlData : ''));
  }

  openUrlFile(urlFile: any) {
    this.baseService.openUrlFile(urlFile);
  }

  createBrandCss(brandColor1: string, brandColor2: string) {
    let css = "";
    // css = ".btn-custom-pri,.custom-menu-section{background-color:" + `${brandColor}` + "}.btn-custom-pri:hover,.btn-custom-pri:focus,.btn-custom-pri:disabled{background-color:" + `${brandColor}` + "}.overview-section .nav-tabs > li > a.active:after {background-color:" + `${brandColor}` + "}a,a:hover{color:" + `${brandColor}` + "}"
    if (brandColor1 && brandColor2) {
      css = ".storeMain .brand-bg-custom, .storeMain .btn-custom-pri,.storeMain .custom-menu-section,.storeMain .btn-custom-pri:hover,.storeMain .btn-custom-pri:focus,.storeMain .btn-custom-pri:disabled,.storeMain .dropdown-item.active,.storeMain .dropdown-item:active,.storeMain .overview-section .nav-tabs > li > a.active:after, .storeMain input.primary:checked+.slider {background:-webkit-linear-gradient(top," + `${brandColor2}` + "," + `${brandColor1}` + ")} .storeMain .brand-bg-custom-overlay {background:-webkit-linear-gradient(top, " + `${brandColor2}45` + "," + `${brandColor1}66` + ")} .storeMain .brand-border {border-image: linear-gradient(45deg, " + `${brandColor2}` + ", " + `${brandColor1}` + ");border-image-slice: 1;border-width:1px;border-style:solid;}"
    } else if (brandColor1 && !brandColor2) {
      css = ".storeMain .brand-bg-custom, .storeMain .btn-custom-pri,.storeMain .custom-menu-section,.storeMain .btn-custom-pri:hover,.storeMain .btn-custom-pri:focus,.storeMain .btn-custom-pri:disabled,.storeMain .dropdown-item.active,.storeMain .dropdown-item:active,.storeMain .overview-section .nav-tabs > li > a.active:after, .storeMain input.primary:checked+.slider {background-color:" + `${brandColor1}` + "} .storeMain .brand-bg-custom-overlay {background-color:" + `${brandColor1}45` + "} .storeMain .brand-border {border:solid 1px" + `${brandColor1}` + "}"
    } else if (!brandColor1 && brandColor2) {
      css = ".storeMain .brand-bg-custom, .storeMain .btn-custom-pri,.storeMain .custom-menu-section,.storeMain .btn-custom-pri:hover,.storeMain .btn-custom-pri:focus,.storeMain .btn-custom-pri:disabled,.storeMain .dropdown-item.active,.storeMain .dropdown-item:active,.storeMain .overview-section .nav-tabs > li > a.active:after, .storeMain input.primary:checked+.slider {background-color:" + `${brandColor2}` + "} .storeMain .brand-bg-custom-overlay {background-color:" + `${brandColor2}45` + "} .storeMain .brand-border {border:solid 1px" + `${brandColor2}` + "}"
    }

    return css;
  }

  // Grid Related

  getGridTotalRecordsCount(total_count: any) {
    if (total_count) {
      const totalCount = total_count ? total_count : 0
      return (totalCount ? totalCount : 0) || 0;
    }
  }

  getGridTotalMessagesCount(data: any) {
    if (data) {
      const totalCount = data.totalRecordCount ? data.totalRecordCount : data.itemCount ? data.itemCount : 0
      return (totalCount ? totalCount : 0) || 0;
    }
  }

  getGridCurrentPage() {
    return 1;
  }

  getGridTotalPages(totalRecordsCount: any, paginationPageSize: any) {
    return Math.ceil((totalRecordsCount / (paginationPageSize || 1)) || 1);
  }

  getGridStartIndex() {
    return 0;
  }

  getGridEndIndex() {
    return 0;
  }

  isPartnerEnabledAppsAllowedToDetilsPage(app: any) {
    return app.enable_state === AppStatesTexts.readytoPublish || app.enable_state === AppStatesTexts.available
  }

  isCustomerEnabledAppsAllowedToDetilsPage(app: any) {
    return app.enable_state === AppStatesTexts.readytoActivate || app.enable_state === AppStatesTexts.enabled
  }

  // Grid Related End

  // alertConfirmCommon(title?: string, text?: string, icon?: any, confirmButtonText?: string, cancelButtonText?: string, showCancelButton?: boolean) {
  //   return Swal.fire({
  //     title: title ? title : "",
  //     text: text ? text : '',
  //     icon: icon ? icon : AlertTypes.info,
  //     showCancelButton: showCancelButton ? showCancelButton : false,
  //     confirmButtonText: confirmButtonText ? confirmButtonText : AlertBtnText.yes,
  //     cancelButtonText: cancelButtonText ? cancelButtonText : AlertBtnText.cancel,
  //     buttonsStyling: false,
  //     customClass: {
  //       confirmButton: 'btn btn-custom-success right-space-15',
  //       cancelButton: 'btn btn-custom-danger'
  //     },
  //     didOpen: () => {
  //       const confirmButton = document.querySelector('.swal2-confirm');
  //       const cancelButton = document.querySelector('.swal2-cancel');

  //       if (confirmButton) confirmButton.id = 'btnConfirm';
  //       if (cancelButton) cancelButton.id = 'btnCancel';
  //     }
  //   })
  // }

  getCarouselDataLenghtAsperViewport() {
    let allowedLength = 8;
    let viewPortWidth = window.innerWidth;
    if (viewPortWidth > 767) {
      allowedLength = 8;
    } else if (viewPortWidth > 575) {
      allowedLength = 5;
    } else if (viewPortWidth < 575) {
      allowedLength = 3;
    }
    return allowedLength;
  }

  createIdString(fromComponent: string, sectionName: string, id: string) {
    if (fromComponent && sectionName) {
      return fromComponent + '-' + sectionName + '-' + id
    } else {
      return id;
    }
  }

  capitalizeFirstLetter(word: string) {
    if (!word) return ""; // Handle empty or null input
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  ngOnDestroy(): void {
    this.destroySubscription = true;
  }
}
